// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { CampaignBuilderAreaId } from './CampaignBuilderAreaId'
import { CampaignBuilderAreaNavigation } from './CampaignBuilderAreaNavigation'
import { CampaignBuilderAreaRoutes } from './CampaignBuilderAreaRoutes'

const LazyCampaignBuilderComponent = lazy(() => import('./CampaignBuilderArea'))

const CampaignBuilderComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyCampaignBuilderComponent />
  </SuspenseLoadingWrapper>
)

export const CampaignBuilderArea = {
  id: CampaignBuilderAreaId,
  requiredRight: BoumRight.AREA_CAMPAIGN_MANAGEMENT,
  NavigationComponent: CampaignBuilderAreaNavigation,
  route: {
    path: CampaignBuilderAreaRoutes.route,
    component: CampaignBuilderComponent,
  },
}
